import "./helpers/safari.js";

// Sections
import modal from './recharge-new/modal/modal.js'
import "./sections/custom-accordion.js";
import "./sections/embla-component.js";
import "./sections/tab-filters.js";

import "./meal-plan/meal-plan.js";
import "./meal-plan/checkout-button.js";
import "./meal-plan/post-filters.js";

import "./sections/quick-view.js";

document.addEventListener("DOMContentLoaded", function () {
  modal().init();
});
